import { ReactElement, FC } from "react";
import { Footer } from "../Footer/Footer";
import { HeaderBlack } from "../HeaderBlack/HeaderBlack";

interface Props {
  children: ReactElement;
  isArticle?: boolean;
}

export const Layout: FC<Props> = ({ children, isArticle }) => {
  return (
    <>
      <HeaderBlack isArticle={isArticle} />
      <main className="pt-[57px]">{children}</main>
      <Footer isArticle={isArticle} />
    </>
  );
};
